export default __webpack_public_path__ + "static/media/image2.60230fe1.jpg";